import { BookingFlow } from "./features/booking/BookingFlow";

export function App() {
  return <BookingFlow />;
}
